/** Transient dialog confirming a product was added to the cart: `{page}/added-to-cart`. */
export const ADDED_TO_CART_DIALOG_SEGMENT = "added-to-cart";
/** Transient dialog summarizing a Buy Again request: `{page}/buy-again-result`. */
export const BUY_AGAIN_RESULT_DIALOG_SEGMENT = "buy-again-result";
/** Leasing inquiry form opened from the cart financing banner: `/cart/leasing-inquiry`. */
export const LEASING_INQUIRY_DIALOG_SEGMENT = "leasing-inquiry";

/**
 * Dialogs that can open on top of any page, so a host route accepts one of them as the
 * last segment of its remainder without listing every host in `allowedOverlayPath`.
 */
export const GLOBAL_DIALOG_SEGMENTS: readonly string[] = [
  ADDED_TO_CART_DIALOG_SEGMENT,
  BUY_AGAIN_RESULT_DIALOG_SEGMENT,
];

/** Drops one trailing global dialog segment from a pathname or route splat. */
export const stripGlobalDialogSegment = (path: string): string => {
  const trimmed = path.replace(/\/+$/, "");
  const lastSlash = trimmed.lastIndexOf("/");
  const last = trimmed.slice(lastSlash + 1);
  return GLOBAL_DIALOG_SEGMENTS.includes(last)
    ? trimmed.slice(0, Math.max(lastSlash, 0))
    : trimmed;
};
